import amazon from './amazon'
import facebook from './facebook'
import github from './github'
import google from './google'
import instagram from './instagram'
import linkedin from './linkedin'
import kakao from './kakao'
import snapchat from './snapchat'
import naver from './naver'
import yahoo from './yahoo'

export default {
  amazon,
  github,
  google,
  facebook,
  instagram,
  linkedin,
  kakao,
  snapchat,
  naver,
  yahoo
}
